<template lang="pug">
  .component-selectize-toc
    selectize(v-if="options", :options="options", value-field="id", :selectedValue="selectedValue" :maxItems="maxItems" label-field="plate", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :renderTemplate="renderTemplate", @itemAdded="optionSelected", placeholder="Toc type")
</template>

<script>
  import Selectize from '../../../Selectize'
  import BaseSelectize from './BaseSelectize'
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
  import MaggieHelper from '../../../../../maggieHelper'
  import ModalReveal from '../../../foundation/ModalReveal'

  export default {
    name: 'SelectizeTocType',
    extends: BaseSelectize,
    components: {ModalReveal, Selectize},
    data() {
      return {
        searchableFields: ['id', 'name'],
      }
    },
    created() {
      this.loadTocs()
    },
    methods: {
      loadTocs() {
        KeplerBackofficeSdk.tocTypes.list.all((data) => {
          this.options = data
        })
      },
      optionTemplate(item, escape) {
        return `<div><div><small>TT${item.id}</small></div><div>${item.name}</div><div><small>${item.group}</small></div></div>`
      },
      renderTemplate(item, escape) {
        return `<div>${item.name}</div>`
      }
    },
    props: ['selectedValue'],

  }
</script>

<style lang="sass">
  .component-selectize-toc

    .add
      padding: 0 10px
</style>



// WEBPACK FOOTER //
// SelectizeTocType.vue?28b246bc